import React from 'react';
import styled from 'styled-components';
import { Colors } from '@origin-digital/style-guide';

export const HorizontalRule = styled('hr')`
  border: none;
  border-bottom: 1px solid ${Colors.GREY16};
  margin: 32px 0 24px 0;
`;
